export const selectHBPrimeData = state => state.hbPrimeReducer || {};